module.exports = __webpack_public_path__ + "static/media/Flame.7fde8c56.png";